module.exports = __webpack_public_path__ + "img/play-square.61c51594.svg";